import React from 'react';
import { Button } from './ui/button';
import { siteContent } from '../data/mock';

const FinalCTA = ({ onCTAClick }) => {
  const { finalCTA } = siteContent;

  return (
    <section className="final-cta-section section-padding" data-testid="final-cta-section">
      <div className="container">
        <div className="final-cta-content">
          <h2 className="final-cta-title" data-testid="final-cta-title">{finalCTA.title}</h2>

          {finalCTA.paragraphs.map((paragraph, index) => (
            <p key={index} className="final-cta-paragraph">{paragraph}</p>
          ))}

          <p className="final-cta-invitation">{finalCTA.invitation}</p>

          <blockquote className="final-cta-verse" data-testid="final-cta-verse">
            {finalCTA.closingVerse}
          </blockquote>

          <Button
            className="cta-button cta-button-large"
            onClick={onCTAClick}
            size="lg"
            data-testid="final-cta-button"
          >
            {finalCTA.buttonText}
          </Button>
          <p className="final-cta-after">{finalCTA.afterButton}</p>
          <p className="final-cta-blessing">{finalCTA.blessing}</p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
